var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goodsStatistics-container" }, [
    _c(
      "header",
      [
        _c("el-input", {
          staticStyle: { width: "180px", "margin-right": "10px" },
          attrs: {
            placeholder: "商品名称",
            "suffix-icon": "el-icon-search",
            size: "mini",
            clearable: ""
          },
          on: { blur: _vm.searchFn, clear: _vm.searchFn },
          model: {
            value: _vm.formData.name,
            callback: function($$v) {
              _vm.$set(_vm.formData, "name", $$v)
            },
            expression: "formData.name"
          }
        }),
        _c(
          "el-button-group",
          [
            _c("el-button", { attrs: { size: "mini" } }, [
              _vm._v(" 发送时间 ")
            ]),
            _c("el-date-picker", {
              staticStyle: { width: "240px", "margin-right": "10px" },
              attrs: {
                size: "mini",
                type: "daterange",
                "value-format": "yyyy-MM-dd ",
                "range-separator": "~",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                clearable: false,
                editable: false,
                "default-time": ["00:00:00", "23:59:59"]
              },
              on: { change: _vm.timeChange },
              model: {
                value: _vm.formData.searchSelectTime,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "searchSelectTime", $$v)
                },
                expression: "formData.searchSelectTime"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "main",
      [
        _c(
          "el-table",
          {
            ref: "tableData",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              height: "calc(100vh - 290px)",
              "default-sort": { prop: "sendTotal", order: "descending" },
              "summary-method": _vm.getSummaries
            },
            on: { "sort-change": _vm.sortChange }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名称", width: "180" }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "shareNumber",
                label: "发送次数",
                sortable: "custom",
                width: "180",
                "sort-method": _vm.sortMethod
              }
            }),
            _c("el-table-column", {
              attrs: {
                sortable: "custom",
                prop: "shareOpenNumber",
                label: "点击次数",
                "sort-method": _vm.sortMethod
              }
            }),
            _c("el-table-column", {
              attrs: {
                sortable: "custom",
                prop: "openRate",
                label: "打开率",
                "sort-method": _vm.sortMethod
              }
            }),
            _c("el-table-column", {
              attrs: {
                sortable: "custom",
                prop: "shelvesOrderNumber",
                label: "商品成交量",
                "sort-method": _vm.sortMethod
              }
            }),
            _c("el-table-column", {
              attrs: {
                sortable: "custom",
                prop: "orderRate",
                label: "商品成交率",
                "sort-method": _vm.sortMethod
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "footer",
      [
        _c("Pagination", {
          attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
          on: { callBack: _vm.callBack }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }